import React from "react";

const CircleLoader = ({ size = 10 }) => {
  return (
    <div
      className={`w-[${size}px] aspect-square rounded-full animate-spin`}
      style={{
        background: `
          radial-gradient(farthest-side,#ffa516 94%,#0000) top/3px 3px no-repeat,
          conic-gradient(#0000 30%,#ffa516)
        `,
        WebkitMask:
          "radial-gradient(farthest-side,#0000 calc(100% - 3px),#000 0)",
      }}
    />
  );
};

export default CircleLoader;